import React from 'react';
import Collapsible from './Collapsible';
import { Modal, Button, Table } from 'react-bootstrap';
// import {required, email, lt} from './validators.js';
import { Textbox } from 'react-inputs-validation';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class UserList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: [],
            originalData: [],
            message: '',
            config: props.config,
            show: false,
            user: {},
            editUser: {
                email: '',
                address: '',
                phone: '',
                gstno: ''
            }
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow(user) {
        this.setState({ user: user });
        this.setState({ show: true });
    }

    handleSave() {
        let body = {}
        this.setState((prev) => ({ user: { ...prev.user, deleted: 0 } }));
        if (this.state.config.type === 'customer') {
            body = { "customer": [this.state.user] };
        } else {
            body = { "vendor": [this.state.user] };
        }
        fetch(this.state.config.url_save, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            // mode: "cors",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                // "Content-Type": "application/x-www-form-urlencoded",
                // Accept: "application/json"
            },
            body: JSON.stringify(body), // body data type must match "Content-Type" header
        })
            .then(response => response.json())
            // .then((parsedJSON) => {
            //         if(this.state.config.type === 'customer'){
            //            return parsedJSON.customer.map(customer => (
            //                 {
            //                     id: `${customer.id}`,
            //                     name: `${customer.name}`,
            //                     email: `${customer.email}`,
            //                     address: `${customer.address}`,
            //                     phone: `${customer.phone}`,
            //                     gstno: `${customer.gstno}`
            //                 }) 
            //             )
            //         } else {
            //             return parsedJSON.vendor.map(vendor => (
            //                 {
            //                     id: `${vendor.id}`,
            //                     name: `${vendor.name}`,
            //                     email: `${vendor.email}`,
            //                     address: `${vendor.address}`,
            //                     phone: `${vendor.phone}`,
            //                     gstno: `${vendor.gstno}`
            //                 }) 
            //             )
            //         }
            // })
            .then((data) => {
                this.setState({
                    user: {},
                    hasError: false
                });
                this.handleClose();
                toast.success("Saved " + this.state.config.type, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 5000
                });
            })
            .catch((error) => {
                console.log(error);
                toast.error("Could not save " + this.state.config.type + ". Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: false
                });
            });
    }

    componentWillMount() {
        localStorage.getItem(this.state.config.type) && this.setState({
            data: JSON.parse(localStorage.getItem(this.state.config.type)),
            originalData: JSON.parse(localStorage.getItem(this.state.config.type)),
            isLoading: false
        })
    }

    componentDidMount() {

        const date = localStorage.getItem(this.state.config.type + "Date");
        const dataDate = date && new Date(parseInt(date, 10));
        const now = new Date();

        const dataAge = Math.round((now - dataDate) / (1000 * 60));

        const tooOld = dataAge >= 15;

        if (tooOld) {
            this.fetchData();
        } else {
            console.log(`Using data from localStorage that are ${dataAge} min old.`)
        }

    }

    fetchData() {
        this.refs.searchForm.reset();
        this.setState({
            isLoading: false,
            data: [],
            originalData: [],
            message: ''
        });
        fetch(this.state.config.url)
            .then(response => response.json())
            .then((parsedJSON) => {
                if (this.state.config.type === 'customer') {
                    return parsedJSON.customer.map(customer => (
                        {
                            id: `${customer.id}`,
                            name: `${customer.name}`,
                            email: `${customer.email}`,
                            address: `${customer.address}`,
                            phone: `${customer.phone}`,
                            gstno: `${customer.gstno}`
                        })
                    )
                } else {
                    return parsedJSON.vendor.map(vendor => (
                        {
                            id: `${vendor.id}`,
                            name: `${vendor.name}`,
                            email: `${vendor.email}`,
                            address: `${vendor.address}`,
                            phone: `${vendor.phone}`,
                            gstno: `${vendor.gstno}`
                        })
                    )
                }
            })
            .then((data) => {
                console.log(data);
                this.setState({
                    data,
                    originalData: data,
                    isLoading: false
                })
            })
            .catch(error => console.log(error))

    }

    componentWillUpdate(nextProps, nextState) {
        localStorage.setItem(this.state.config.type, JSON.stringify(nextState.originalData));
        localStorage.setItem(this.state.config.type + 'Date', Date.now());
    }


    filterCriteria(e) {
        e.preventDefault();
        const searchText = this.refs.inputText.value;
        const filteredList = this.state.originalData.filter(data => data.name.toLowerCase().includes(searchText.toLowerCase()));

        this.setState({
            data: filteredList,
            message: filteredList.length > 0 ? '' : 'No matching ' + this.state.config.type
        });
    }

    render() {
        const { isLoading, data, message, config } = this.state;
        return (
            <div>
                <header>
                    <h1>{config.title} <button className="btn btn-sm btn-danger" onClick={(e) => {
                        this.fetchData();
                    }}>Refresh</button></h1>
                </header>
                <div>
                    <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                        <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{ width: "100%", marginBottom: "10px", padding: "5px", borderColor: "red" }} autoComplete="off"></input>
                    </form>
                </div>
                <div className={`content ${isLoading ? 'is-loading' : ''}`} style={{ minHeight: "50px", maxHeight: "500px", overflowX: "scroll" }}>
                    <p style={{ color: "red", paddingLeft: "20px" }}>{message}</p>
                    <div className="panel-group">
                        {
                            !isLoading && data.length > 0 ? data.map(data => {
                                const { id, name, email, address, phone, gstno } = data;
                                return <Collapsible key={id} title={name} user={data} onEditClick={this.handleShow} hasEditFeature={true}>
                                    <Table striped bordered condensed hover>
                                        <tbody>
                                            <tr>
                                                <td>Email</td>
                                                <td>{email}</td>
                                            </tr>
                                            <tr>
                                                <td>Address</td>
                                                <td>{address}</td>
                                            </tr>
                                            <tr>
                                                <td>Phone</td>
                                                <td>{phone}</td>
                                            </tr>
                                            <tr>
                                                <td>GST No</td>
                                                <td>{gstno}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Collapsible>
                            }) : null
                        }
                    </div>
                    {
                        this.state.show &&
                        <Modal show={this.state.show} onHide={this.handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>{this.state.user.name}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <form>
                                    {/* <FormGroup>
                                            <ControlLabel>Name</ControlLabel>
                                            <FormControl.Static>{this.state.user.name}</FormControl.Static>
                                        </FormGroup> */}

                                    <Textbox
                                        tabIndex="1" //Optional.[String or Number].Default: -1.
                                        id={'email'} //Optional.[String].Default: "".  Input ID.
                                        name="email" //Optional.[String].Default: "". Input name.
                                        type="text" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                        value={this.state.user.email} //Optional.[String].Default: "".
                                        placeholder="Email Address" //Optional.[String].Default: "".
                                        validate={true}
                                        validationCallback={res => this.setState({ hasError: res, validate: false })}
                                        onChange={(email, e) => {
                                            let u = this.state.user;
                                            u.email = email;
                                            this.setState({ user: u });
                                        }} //Required.[Func].Default: () => {}. Will return the value.
                                        //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        validationOption={{
                                            name: 'Email', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                            check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: false, //Optional.[Bool].Default: true. To determin if it is a required field.
                                            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            regMsg: 'Email id is not valid'
                                        }}
                                    //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    />

                                    <Textbox
                                        tabIndex="1" //Optional.[String or Number].Default: -1.
                                        id={'address'} //Optional.[String].Default: "".  Input ID.
                                        name="address" //Optional.[String].Default: "". Input name.
                                        type="text" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                        value={this.state.user.address} //Optional.[String].Default: "".
                                        placeholder="Address" //Optional.[String].Default: "".
                                        validate={true}
                                        validationCallback={res => this.setState({ hasError: res, validate: false })}
                                        onChange={(address, e) => {
                                            let u = this.state.user;
                                            u.address = address;
                                            this.setState({ user: u });
                                        }} //Required.[Func].Default: () => {}. Will return the value.
                                        //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        validationOption={{
                                            name: 'Address', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                            check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                            //reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            //regMsg: 'Email id is not valid'
                                        }}
                                    //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    />

                                    <Textbox
                                        tabIndex="1" //Optional.[String or Number].Default: -1.
                                        id={'phone'} //Optional.[String].Default: "".  Input ID.
                                        name="phone" //Optional.[String].Default: "". Input name.
                                        type="phone" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                        value={this.state.user.phone} //Optional.[String].Default: "".
                                        placeholder="Phone" //Optional.[String].Default: "".
                                        validate={true}
                                        validationCallback={res => this.setState({ hasError: res, validate: false })}
                                        onChange={(phone, e) => {
                                            let u = this.state.user;
                                            u.phone = phone;
                                            this.setState({ user: u });
                                        }} //Required.[Func].Default: () => {}. Will return the value.
                                        //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        validationOption={{
                                            name: 'Phone', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                            check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                            //reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            //regMsg: 'Email id is not valid'
                                        }}
                                    //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    />

                                    <Textbox
                                        tabIndex="1" //Optional.[String or Number].Default: -1.
                                        id={'gstno'} //Optional.[String].Default: "".  Input ID.
                                        name="gstno" //Optional.[String].Default: "". Input name.
                                        type="text" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                        value={this.state.user.gstno} //Optional.[String].Default: "".
                                        placeholder="GST No" //Optional.[String].Default: "".
                                        validate={true}
                                        validationCallback={res => this.setState({ hasError: res, validate: false })}
                                        onChange={(gstno, e) => {
                                            let u = this.state.user;
                                            u.gstno = gstno;
                                            this.setState({ user: u });
                                        }} //Required.[Func].Default: () => {}. Will return the value.
                                        //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        validationOption={{
                                            name: 'GST No', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                            check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                            //reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            //regMsg: 'Email id is not valid'
                                        }}
                                    //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    />

                                </form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="submit" onClick={this.handleSave}>Save</Button>
                                <Button onClick={this.handleClose}>Cancel</Button>
                            </Modal.Footer>
                        </Modal>
                    }
                    <div className="loader">
                        <div className="icon"></div>
                    </div>
                </div>
            </div>
        );
    }

}
export default UserList;



// WEBPACK FOOTER //
// ./src/js/UserList.js